export default __webpack_public_path__ + "static/media/canadaFlag.f995d117.svg";